import { z } from 'zod';

export const chiefComplaintSchema = z.object({
  complaint: z.string().optional(),
  excerpt: z.array(z.string()).optional(),
  confidence: z.number(),
});
